

export class Constant {
   

    
    
 
   

 
    //Initialization
    static config: any = {};
    static uri = {
        amlReviewURI: '',
         amlReviewURINoGroup: '',
        
        advisorHierarchy:'',
        amlSaveDeletGroupURI: '',
        downloadPDFNameURI: '',
        questionnaire: '',
saveresponses: '',
responsesbyreview:'',
generatePDF: '',
generateFromHtml:'',
basePDFURL: '',
       uploadPDF: '', 
       getCrmAccessToken: '',
         getCrmContacts: '',
       getCrmInteraction: '',
       getCrmOwner: '',
       updatePeriodicClientCRMSync: '',
       getCrmAccounts: '',
    };

    static routes = {
        home: 'amlhome',
       
    };

    static updateConfig = ((configvalues: any) => {

        Constant.config.clientId = configvalues.clientid;
        Constant.config.instance = configvalues.instance;
        Constant.config.tenant = configvalues.tenant;
        Constant.config.appInsightKey = configvalues.appinsightkey;
        Constant.config.scope = configvalues.scope;
        Constant.config.scopes = configvalues.scope.split(',');
        Constant.config.autority = configvalues.instance + configvalues.tenant;
        Constant.config.superUsers = configvalues.superusers ? (<string>configvalues.superusers).toLocaleUpperCase().split(',') : [];
        Constant.config.pptUrl = configvalues.ppturl;
        Constant.config.compusers = configvalues.compusers ? (<string>configvalues.compusers).toLocaleUpperCase().split(',') : [];
        Constant.config.nfsreportenable = configvalues.nfsreportenable ? configvalues.nfsreportenable : "N";
        Constant.config.env = configvalues.env;

        Constant.config.latestMonth = configvalues.latestmonth;
        Constant.config.latestYr = configvalues.latestyr;

        Constant.config.apiBaseUrl = configvalues.apibaseurl;
        Constant.config.apiEnvUrl = configvalues.apienvurl;
        Constant.config.dynamicCrmBaseUrl = configvalues.dynamiccrmbaseurl;

        Constant.config.enableCrmInteraction = configvalues.enablecrminteraction ? configvalues.enablecrminteraction : "N";

        Constant.uri.amlReviewURI = configvalues.apibaseurl + 'aml/client-reviews';

        Constant.uri.amlReviewURINoGroup = configvalues.apibaseurl + 'aml/client-reviews-noGroup';
        Constant.uri.amlSaveDeletGroupURI = configvalues.apibaseurl + 'aml/save-group';
          Constant.uri.questionnaire = configvalues.apibaseurl + 'aml/questionnaire';
            Constant.uri.saveresponses = configvalues.apibaseurl + 'aml/save-responses';
             Constant.uri.responsesbyreview = configvalues.apibaseurl + 'aml/responses-by-review';
            //  Constant.uri.generatePDF = configvalues.apibaseurl + 'aml/generate-response-pdf';
             Constant.uri.generateFromHtml = configvalues.apibaseurl + 'aml/generate-from-html';
Constant.uri.generatePDF = configvalues.basePdfUrl+'generate-pdf';
Constant.uri.generatePDF = configvalues.basePdfUrl+'generate-pdf';
Constant.uri.downloadPDFNameURI = configvalues.apibaseurl + 'aml/download-pdf';

        Constant.uri.advisorHierarchy = `${Constant.config.apiBaseUrl}Advisors/AdvisorHirerarchy`;
Constant.uri.uploadPDF = configvalues.apibaseurl + 'aml/upload';
// url for dynamic CRM communication
        Constant.uri.getCrmAccessToken = `${Constant.config.dynamicCrmBaseUrl}.default`;        
        Constant.uri.getCrmContacts = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/contacts`;
        Constant.uri.getCrmInteraction = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/aka_meetingnotes`;
        Constant.uri.getCrmOwner = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/systemusers`;
        Constant.uri.updatePeriodicClientCRMSync = `${Constant.config.apiBaseUrl}aml/update-crm-sync`;
        Constant.uri.getCrmAccounts = `${Constant.config.dynamicCrmBaseUrl}api/data/v9.2/accounts`;
        });


}
